class AllowedControls { 
    get controls() {
      return {
          // Controls:
          'control_bar_chart': {allowed: true},
          'control_gauge_chart': {allowed: true},
          'control_bullet_text': {allowed: true},
          'control_button': {allowed: true},
          'control_captcha': {allowed: true},
          'control_checkbox': {allowed: true},
          'control_checkbox_group': {allowed: true},
          'control_crosstab': {allowed: false},
          'control_clear_filter_button': {allowed: true},
          'control_filter_input': {allowed: true},
          'control_data_grid': {allowed: true},
          'control_data_list': {allowed: false},
          'control_date_calendar': {allowed: false},
          'control_date_input': {allowed: true},
          'control_drop_down':    {allowed: true},
          'control_file_attachment': {allowed: true},
          'control_filter_selector': {allowed: true},
          //'control_filter_setter': {allowed: true},
          //'control_gauge':    {allowed: false},
          'control_group':  {allowed: false},
          'control_horizontal_separator': {allowed: true},
          'control_horizontal_slider': {allowed: true}, 
          'control_image_input':  {allowed: false},
          'control_large_heading': {allowed: true},
          'control_line_chart':{allowed: true},
          'control_link':  {allowed: true},
          'control_list': {allowed: true},
          'control_mask_text_input': {allowed: true},
          'control_medium_heading': {allowed: true}, 
          'control_movie': {allowed: false},
          'control_multiple_text_input': {allowed: true},
          'control_numeric_input': {allowed: true},
          'control_numeric_stepper': {allowed: true},
          'control_page':        {allowed: true},
          'control_page_button':  {allowed: true},
          'control_password_input':{allowed: true},
          'control_picture':  {allowed: true},
          'control_pie_chart':   {allowed: true},
          'control_play_form_button': {allowed: true},
          'control_play_report_button': {allowed: true},
          'control_print_button':{allowed: true},
          'control_progress_bar': {allowed: true},
          'control_radio_button': {allowed: true},
          'control_radio_button_group':{allowed: true},
          'control_ranking': {allowed: false},
          'control_small_heading': {allowed: true},
          'control_small_text': {allowed: true},
          'control_sound': {allowed: false},
          'control_submit_button': {allowed: true},
          'control_table': {allowed: true},
          'control_text': {allowed: true},
          'control_text_input': {allowed: true},
          'control_text_search': {allowed: true},
          'control_time_input': {allowed: true},          
          'control_timer': {allowed: false},
          'control_value': {allowed: true},
          'control_vertical_separator':{allowed: false},
          'control_vertical_slider': {allowed: false},
          'control_websignature':  {allowed: true},
          'control_hello_world': {allowed: true}
      }      
    }  
    
    isAllowed(control) {
        return this.controls[control].allowed;
    }
}

export default new AllowedControls();